const CloseCashierCard = ({ list, title }) => {
  return (
    <div>
      {title && <p className="bold">{title}</p>}
      <div className="cards-closed mb-4 ">
        {list.map((item, i) => (
          <p key={i}>
            {item.name}:
            <span className="ms-1">
              {"$" + new Intl.NumberFormat("es-CL").format(item.value)}
            </span>
          </p>
        ))}
      </div>
    </div>
  );
};

export default CloseCashierCard;
